import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"
import _imports_0 from '@/assets/img/icon/voucher-outline-black.svg'
import _imports_1 from '@/assets/img/icon/dollar-outline-grey.svg'


const _hoisted_1 = {
  class: "flex w-full items-center justify-between",
  style: {"padding":"0px 5px 8px 5px","border-bottom":"1px solid #cfd8dc"}
}
const _hoisted_2 = { class: "text-2xl font-bold" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  key: 0,
  class: ""
}
const _hoisted_5 = { class: "" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text base font-semibold mb-4" }, "Spesifikasi Item", -1)
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = { class: "lg:flex items-center gap-4 mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal required lg:w-1/5" }, "Nama Item", -1)
const _hoisted_10 = { class: "lg:w-4/5" }
const _hoisted_11 = { class: "invalid-feedback" }
const _hoisted_12 = { class: "lg:flex gap-4 mb-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal required lg:w-1/5" }, "Voucher", -1)
const _hoisted_14 = { class: "lg:w-4/5" }
const _hoisted_15 = { class: "invalid-feedback" }
const _hoisted_16 = {
  key: 0,
  class: "flex gap-4 mb-3 ml-4 justify-end"
}
const _hoisted_17 = { class: "lg:flex gap-4 w-full lg:w-4/5" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "mt-3 lg:mt-0" }
const _hoisted_20 = { class: "mb-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-bold" }, "Deskripsi Voucher: ", -1)
const _hoisted_22 = { class: "text-xs" }
const _hoisted_23 = { class: "mb-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", null, "Deskripsi Voucher", -1)
const _hoisted_25 = { class: "mb-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", null, "Kode Voucher", -1)
const _hoisted_27 = { class: "mb-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", null, "Diskon & Potongan", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Kuota Voucher"),
  /*#__PURE__*/_createElementVNode("div", null, /*#__PURE__*/_toDisplayString(0))
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Penukaran Poin"),
  /*#__PURE__*/_createElementVNode("div", null, /*#__PURE__*/_toDisplayString(0))
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Grup User"),
  /*#__PURE__*/_createElementVNode("div", null, /*#__PURE__*/_toDisplayString('-'))
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-bold" }, "Diskon & Potongan", -1)
const _hoisted_33 = { class: "text-xs" }
const _hoisted_34 = { class: "lg:flex items-center gap-4 mb-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal required lg:w-1/5" }, "Jumlah Item", -1)
const _hoisted_36 = { class: "lg:w-4/5" }
const _hoisted_37 = { class: "p-inputgroup flex-1" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Item", -1)
const _hoisted_39 = { class: "invalid-feedback" }
const _hoisted_40 = {
  key: 0,
  class: "mt-40px"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", null, "Harga Item", -1)
const _hoisted_42 = { class: "p-3 rounded-lg border-grey-3 mt-3" }
const _hoisted_43 = { class: "flex items-center gap-4 mb-2" }
const _hoisted_44 = { class: "p-2 rounded-lg border-grey-3 flex items-center w-full" }
const _hoisted_45 = { class: "w-1/4 pr-3 flex items-center gap-2" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "items"
}, null, -1)
const _hoisted_47 = { class: "text-xs text-grey font-semibold" }
const _hoisted_48 = { class: "w-3/4 border-left-grey-3 pl-3 flex items-center gap-2" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "price"
  })
], -1)
const _hoisted_50 = { class: "text-xs text-grey font-semibold" }
const _hoisted_51 = { class: "mb-4 flex gap-4" }
const _hoisted_52 = { class: "md:w-1/2" }
const _hoisted_53 = { class: "mt-20px border-grey-4-dashed rounded-lg p-2" }
const _hoisted_54 = { class: "md:w-1/2" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Harga Jual (sesuai jumlah item yang dijual)", -1)
const _hoisted_56 = { class: "p-inputgroup flex-1" }
const _hoisted_57 = { class: "p-inputgroup-addon" }
const _hoisted_58 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_59 = { class: "flex items-center gap-3 justify-end mt-40px" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_61 = /*#__PURE__*/_createTextVNode("Simpan")

import { toRefs, onMounted, ref, getCurrentInstance, watch } from 'vue'
import Dialog from 'primevue/dialog'
import InputSwitch from 'primevue/inputswitch'
import rupiahFormat from '@/utils/helpers/rupiahFormat'
import InputText from 'primevue/inputtext'
import { Form, Field, configure } from 'vee-validate'
import * as Yup from 'yup'
import SelectAsync from '@/views/components/form/SelectAsync.vue'
import InputNumber from 'primevue/inputnumber'
import Button from 'primevue/button'
import Dropdown from 'primevue/dropdown'
import apiUseCase from '@/usecase/apiUseCase'
import { useStore } from 'vuex'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import apiOpenUseCase from '@/usecase/apiOpenUseCase'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import { useRoute } from 'vue-router'
import { isNull } from 'lodash'
import rgxExp from '@/utils/helpers/regExp'
import SelectAsyncOpen from '@/views/components/form/SelectAsyncOpen.vue'
import numberFormat from '@/utils/helpers/numberFormat'
import Popper from 'vue3-popper'
import moment from 'moment'


export default /*#__PURE__*/_defineComponent({
  __name: 'VoucherForm',
  props: {
  show: {
    type: Boolean,
    default: false
  },
  index: {
    default: null as any
  },
  dataItem: {
    default: null as any
  },
  itemList: {
    default: [] as any
  }
},
  emits: ["hideDialog", "refreshHeader", "onSubmitAct"],
  setup(__props, { emit }: { emit: ({
  (e: 'hideDialog'): void
  (e: 'refreshHeader'): void
  (e: 'onSubmitAct', data: any, index: any): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const voucherEndpoint = 'voucher/v1/vouchers'
const detailPriceEndpoint = 'management/v1/MsDetilPrice'
const bundleEndpoint = 'ticket/v1/Bundles'
const {
  show,
  index,
  dataItem,
  itemList
} = toRefs(props)
const app = getCurrentInstance()
const {
  $toast, $strInd
} = app!.appContext.config.globalProperties
configure({
  validateOnBlur: false,
  validateOnChange: false,
  validateOnInput: false,
  validateOnModelUpdate: false,
})
const store = useStore()
const route = useRoute()
const showModal = show.value
const idPrams = ref(null) as any
const isPp = ref(false)
const trayekDetail = ref(null) as any
const voucherDetail = ref(null) as any
const rit1Price = ref(null) as any
const rit2Price = ref(null) as any
const isLoading = ref(false)
const isLoadingDetail = ref(true)
const isPpPriceNotMatch = ref(false)
const totalOriginalPrice = ref(0)
const tempDiscount = ref(0)
const title = ref('Tambah')

const initialValues = ref({
  Id: null as any,
  Name: '',
  Voucher: null as any,
  ItemSold: 0,
  TotalItemPrice: 0
})

const schema = Yup.object().shape({
  Name: Yup.string().required('Nama Item harus diisi')
    .min(3, 'Nama Item minimal 3 karakter')
    .max(50, 'Nama Item maksimal 50 karakter')
    .matches(rgxExp.notPrefixSpace, 'Nama Item tidak boleh hanya menggunakan spasi')
    .test('unique-name', 'Nama Item sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const filterResult = itemList?.value.filter((x: any) => x.DisplayName === val && x.Id !== dataItem?.value.Id)
        if (route.params.id) {
          return filterResult.length === 0 || val === initialValues.value.Name
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  Voucher: Yup.object().typeError('Voucher harus diisi').required('Voucher harus diisi'),
  ItemSold: Yup.number().required('Jumlah Item harus diisi').moreThan(0, 'Jumlah Item tidak boleh 0').lessThan(100000, 'Jumlah Item minimal 5 karakter'),
  TotalItemPrice: Yup.number().required('Harga Jual harus diisi')
})

const closeDialog = () => {
  emit('hideDialog')
}

const onSubmitForEdit = async (payload: any) => {
  store.dispatch('showLoading')
  await apiOpenUseCase.postOrPut(`${bundleEndpoint}/${idPrams.value?.Id}/Items`, payload?.Id ?? null, payload).then((response) => {
    const { error, message } = response
    if (!error) {
      $toast.add({
        severity: 'success',
        detail: `Item berhasil ${payload.Id ? 'diubah' : 'ditambahkan'}`,
        group: 'bc',
        closable: false,
        life: 3000
      })
      closeDialog()
      emit('refreshHeader')
    } else {
      $toast.add({
        severity: 'error',
        summary: 'Gagal!',
        detail: message,
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  })
  store.dispatch('hideLoading')
}

const onSubmit = (values: any) => {
  if (tempDiscount.value < 0) {
    $toast.add({
      severity: 'error',
      detail: 'Harga Jual harus lebih kecil dari (Harga Normal x Jumlah Karcis)',
      group: 'bc',
      closable: false,
      life: 3000
    })
  } else {
    let obj = null as any
    if (idPrams.value) {
      obj = {
        Id: values.Id,
        BundleId: idPrams.value?.Id,
        BundleItemType: 'Voucher',
        DisplayName: values.Name ?? '-',
        Quantity: values.ItemSold ?? 0,
        OriginalPrice: 0,
        BundlePrice: values.TotalItemPrice ?? 0,
        TotalDiscount: tempDiscount.value,
        IsActive: true,
        // TrayekDetail: trayekDetail.value,
        BundleItemRoutes: [],
        BundleItemSnack: null,
        BundleItemVoucher: {
          VoucherId: voucherDetail.value?.id,
          Title: voucherDetail.value?.title,
          Description: voucherDetail.value?.description,
          Code: voucherDetail.value?.code,
          ThumbnailUrl: voucherDetail.value?.imageUrl,
          ActivationDate: voucherDetail.value?.activationDate ?? null,
          ExpiryDate: voucherDetail.value?.expiryDate ?? null
        }
      }
      onSubmitForEdit(obj)
    } else {
      obj = {
        Id: values.Id,
        BundleItemType: 'Voucher',
        DisplayName: values.Name ?? '-',
        Quantity: values.ItemSold ?? 0,
        OriginalPrice: 0,
        BundlePrice: values.TotalItemPrice ?? 0,
        TotalDiscount: tempDiscount.value,
        IsActive: true,
        TrayekDetail: trayekDetail.value,
        BundleItemRoutes: [],
        BundleItemSnack: null,
        BundleItemVoucher: {
          VoucherId: voucherDetail.value?.id,
          Title: voucherDetail.value?.title,
          Description: voucherDetail.value?.description,
          Code: voucherDetail.value?.code,
          ThumbnailUrl: voucherDetail.value?.imageUrl,
          ActivationDate: voucherDetail.value?.activationDate ?? null,
          ExpiryDate: voucherDetail.value?.expiryDate ?? null
        }
      }
      emit('onSubmitAct', obj, index?.value)
      closeDialog()
    }
  }
}

const getVoucherDetail = async (data: any) => {
  console.log('dataS', data)
  if (data) {
    store.dispatch('showLoading')
    await apiOpenUseCase.get(`${voucherEndpoint}/${data.id ?? data.Id}`).then((response) => {
      const { error, result } = response
      if (!error) {
        voucherDetail.value = result
        isLoadingDetail.value = true
      }
    })
    store.dispatch('hideLoading')
  } else {
    voucherDetail.value = null
  }
}

const usedRitId = ref([]) as any

watch(rit2Price, (val: any) => {
  console.log('watch', [val, rit1Price.value, isPp.value])
  if ((val?.Bruto !== rit1Price.value?.Bruto) && isPp.value) {
    isPpPriceNotMatch.value = true
  } else {
    isPpPriceNotMatch.value = false
  }
})

watch(isPp, (val: any) => {
  // console.log('isPp', val)
  if (!val) {
    isPpPriceNotMatch.value = false
  }
})

const countTempDiscount = (qty: any, price: any) => {
  const originalPrice = 0
  const newPrice = price
  totalOriginalPrice.value = qty * originalPrice
  // tempDiscount.value = Math.round(((totalOriginalPrice.value - newPrice) / totalOriginalPrice.value) * 100) ?? 0
  tempDiscount.value = 0
}

const defineInitialValues = (data: any) => {
  initialValues.value.Id = data.Id
  initialValues.value.Name = data.DisplayName
  initialValues.value.Voucher = voucherDetail.value ? { ...voucherDetail.value, label: voucherDetail.value?.title } : null
  initialValues.value.ItemSold = data.Quantity ?? 0
  initialValues.value.TotalItemPrice = data.BundlePrice ?? 0
  totalOriginalPrice.value = data.OriginalPrice
  tempDiscount.value = data.TotalDiscount
  // isLoadingDetail.value = false
  isLoading.value = false
  console.log('total', data)
}

const getItemData = async (data: any) => {
  console.log('data', data)
  isLoading.value = true
  // if (data?.Id) {
  //   await apiOpenUseCase.get(`${trayekEndpoint}/${idPrams.value.Id}/Items/${data.Id}`).then((response) => {
  //     console.log('response', response)
  //   })
  // }

  await getVoucherDetail({ Id: data?.BundleItemVoucher?.VoucherId })

  defineInitialValues(data)
}

onMounted(() => {
  console.log('asdadads', [index?.value, dataItem?.value, itemList?.value])
  if (route.params.id) {
    idPrams.value = encryptDecriptMethods.decrypt(route.params.id)
  }
  if (dataItem?.value) {
    title.value = 'Edit'
    getItemData(dataItem.value)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Dialog), {
      class: "subscription-item-form",
      showHeader: true,
      visible: _unref(showModal),
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_isRef(showModal) ? (showModal).value = $event : null)),
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '75vw' },
      modal: true,
      contentClass: "wrap-ctn-modal-default"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(`${title.value} Item Paket`), 1),
          _createElementVNode("div", null, [
            _createElementVNode("i", {
              class: "pi pi-times cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (closeDialog()))
            })
          ])
        ])
      ]),
      footer: _withCtx(() => []),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(Form), {
                    onSubmit: onSubmit,
                    "validation-schema": _unref(schema),
                    "initial-values": initialValues.value,
                    class: "form-container"
                  }, {
                    default: _withCtx(({ errors, setFieldValue, values }) => [
                      _createElementVNode("div", null, [
                        _hoisted_6,
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _hoisted_9,
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_unref(Field), { name: "Name" }, {
                                default: _withCtx(({ field, handleChange, handleBlur }) => [
                                  _createVNode(_unref(InputText), _mergeProps(field, {
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    placeholder: "Masukkan nama item",
                                    autocomplete: "off"
                                  }), null, 16, ["onChange", "onBlur"])
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_11, _toDisplayString(errors.Name), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_unref(Field), { name: "Voucher" }, {
                                default: _withCtx(({ field }) => [
                                  _createVNode(SelectAsyncOpen, _mergeProps(field, {
                                    placeholder: 'Pilih Voucher',
                                    modelValue: field.value,
                                    disabled: false,
                                    id: 'voucher',
                                    inputId: 'voucher',
                                    endpoint: "/voucher/v1/vouchers",
                                    classname: 'custom-select',
                                    searchCustom: [['status', '=', 'Active']],
                                    fieldLabel: (v) => `${v.title}`,
                                    clearable: false,
                                    searchFields: ['title'],
                                    "onUpdate:modelValue": (v) => (getVoucherDetail(v), setFieldValue('Route', null), setFieldValue('PassengerType', null), setFieldValue('OriginTerminal', null), setFieldValue('DestinationTerminal', null), isPp.value = false, rit1Price.value = null, rit2Price.value = null)
                                  }), null, 16, ["modelValue", "fieldLabel", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("div", _hoisted_15, _toDisplayString(errors.Voucher), 1)
                            ])
                          ]),
                          (_unref(voucherDetail))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                  _createElementVNode("img", {
                                    src: _unref(voucherDetail)?.imageUrl,
                                    alt: "voucherImg",
                                    class: "w-full lg:w-1/3"
                                  }, null, 8, _hoisted_18),
                                  _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, [
                                      _hoisted_21,
                                      _createVNode(_unref(Popper), {
                                        arrow: "",
                                        hover: ""
                                      }, {
                                        content: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_23, [
                                            _hoisted_24,
                                            _createElementVNode("div", null, _toDisplayString(_unref(voucherDetail)?.description), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_25, [
                                            _hoisted_26,
                                            _createElementVNode("div", null, _toDisplayString(_unref(voucherDetail)?.code), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_27, [
                                            _hoisted_28,
                                            _createElementVNode("div", null, _toDisplayString(_unref(voucherDetail)?.valueType === 'Percentage' ? `${_unref(numberFormat)(_unref(voucherDetail)?.value)} %` : `${_unref(rupiahFormat)(_unref(voucherDetail)?.value)}`), 1)
                                          ]),
                                          _hoisted_29,
                                          _hoisted_30,
                                          _hoisted_31
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(voucherDetail)?.description), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", null, [
                                      _hoisted_32,
                                      _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(voucherDetail)?.valueType === 'Percentage' ? `${_unref(numberFormat)(_unref(voucherDetail)?.value)} %` : `${_unref(rupiahFormat)(_unref(voucherDetail)?.value)}`), 1)
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_34, [
                            _hoisted_35,
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(_unref(Field), {
                                name: "ItemSold",
                                class: _normalizeClass(`${errors.ItemSold ? 'input-invalid' : ''}`)
                              }, {
                                default: _withCtx(({ }) => [
                                  _createElementVNode("div", _hoisted_37, [
                                    _createVNode(_unref(InputNumber), {
                                      modelValue: values.ItemSold,
                                      "onUpdate:modelValue": ($event: any) => ((values.ItemSold) = $event),
                                      class: _normalizeClass(`${errors.ItemSold ? 'input-invalid' : ''}`),
                                      id: "ItemSold",
                                      placeholder: "0",
                                      min: 0,
                                      currency: "IDR",
                                      locale: "id-ID",
                                      step: 0.25,
                                      inputId: "refund-amount",
                                      onInput: (v) => {
                            setFieldValue('ItemSold', v.value)
                          },
                                      onBlur: ($event: any) => (countTempDiscount(values.ItemSold, values.TotalItemPrice ?? 0)),
                                      allowEmpty: false,
                                      autocomplete: "off"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "step", "onInput", "onBlur"]),
                                    _hoisted_38
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["class"]),
                              _createElementVNode("div", _hoisted_39, _toDisplayString(errors.ItemSold), 1)
                            ])
                          ])
                        ])
                      ]),
                      (isLoadingDetail.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            _hoisted_41,
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("div", _hoisted_44, [
                                  _createElementVNode("div", _hoisted_45, [
                                    _hoisted_46,
                                    _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(voucherDetail)?.code), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_48, [
                                    _hoisted_49,
                                    _createElementVNode("div", _hoisted_50, _toDisplayString(`Harga normal: ${_unref(rupiahFormat)(_unref(rit1Price) ? _unref(rit1Price).Bruto : 0)}`), 1)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("div", _hoisted_52, [
                                  _createElementVNode("div", _hoisted_53, _toDisplayString(`Harga Normal x Jumlah Item: ${_unref(rupiahFormat)((totalOriginalPrice.value ?? 0))}`), 1)
                                ]),
                                _createElementVNode("div", _hoisted_54, [
                                  _hoisted_55,
                                  _createVNode(_unref(Field), {
                                    name: "TotalItemPrice",
                                    class: _normalizeClass(`${errors.TotalItemPrice ? 'input-invalid' : ''}`)
                                  }, {
                                    default: _withCtx(({ meta }) => [
                                      _createElementVNode("div", _hoisted_56, [
                                        _createVNode(_unref(InputNumber), {
                                          modelValue: values.TotalItemPrice,
                                          "onUpdate:modelValue": ($event: any) => ((values.TotalItemPrice) = $event),
                                          class: _normalizeClass(`${errors.TotalItemPrice ? 'input-invalid' : ''}`),
                                          id: "TotalItemPrice",
                                          placeholder: "0",
                                          min: 0,
                                          currency: "IDR",
                                          locale: "id-ID",
                                          step: 0.25,
                                          inputId: "refund-amount",
                                          onInput: (v) => {
                            setFieldValue('TotalItemPrice', v.value)
                          },
                                          onBlur: ($event: any) => (countTempDiscount(values.ItemSold, values.TotalItemPrice ?? 0)),
                                          allowEmpty: false,
                                          autocomplete: "off"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "step", "onInput", "onBlur"]),
                                        _createElementVNode("span", _hoisted_57, _toDisplayString(`Diskon ${tempDiscount.value}%`), 1)
                                      ]),
                                      (meta.touched && !meta.valid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(errors.TotalItemPrice), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["class"])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_59, [
                        _createVNode(_unref(Button), {
                          class: "btn-back mr-2",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (closeDialog()))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_60
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(Button), {
                          type: "submit",
                          class: "btn-primary mr-1"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_61
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["validation-schema", "initial-values"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})